// extracted by mini-css-extract-plugin
export default {"campoFecha":"CampoEditableFecha_campoFecha__H4NF9"};